const SEEN_LIMIT = 500;

/**
 * Descarta eventos já aplicados. A ordem de inserção do Set é a ordem de chegada.
 */
export function takeFreshEvents(seen, events, limit = SEEN_LIMIT) {
  const next = new Set(seen);
  const fresh = [];

  for (const event of events || []) {
    const id = event && event.id ? String(event.id) : '';
    if (id && next.has(id)) {
      continue;
    }
    if (id) {
      next.add(id);
    }
    fresh.push(event);
  }

  while (next.size > limit) {
    const oldest = next.values().next().value;
    next.delete(oldest);
  }

  return { seen: next, events: fresh };
}
